import React, { Component } from 'react';
import classNames from 'classnames';

import { connect } from 'react-redux';
import DetailsModal from '../../global/DetailsModal';
import getCurrencyPrefix from '../../../common/getCurrencyPrefix';
import { getHrefLang } from '../../../store/selectors/general.selectors';
import {
  getIsProductAddonModifierOptionInventoryPending,
} from '../../../store/selectors/product.selectors';

export class CheckboxModifiersComponent extends Component {
  renderModal(modal) {
    const {
      fetchProductDetailsAction,
    } = this.props;

    return modal && (
      <DetailsModal
        teaserCopy={modal.teaserCopy}
        teaserIcon={modal.teaserIcon}
        salesTiers={modal.salesTiers}
        popUpCopy={modal.copy}
        fetchProductDetails={fetchProductDetailsAction}
        header={modal.header}
        footnote={modal.footnote}
        asset={modal.assets && modal.assets[0]}
        links={modal.links}
      />
    );
  }

  getTotalPriceAdjust(modifierPriceAdjust, modifierValue) {
    const { productDetails, selectedModifierOptions } = this.props;

    let inferredAddOnPrice = 0;
    if (productDetails.skuSplit.type === 'OLRST' && modifierValue.startsWith('AOSTCV')) {
      const isOttomanCoverModifierSelected = selectedModifierOptions.some((m) => m.value === 'OLRST-OT-RY-S0-A0');
      if (isOttomanCoverModifierSelected) {
        inferredAddOnPrice = productDetails.inferredAddOn?.product?.price?.raw || 0;
      }
    }

    if (productDetails.skuSplit.type === 'ODST' && modifierValue.startsWith('OSTCV')) {
      const isOttomanCoverModifierSelected = selectedModifierOptions.some((m) => m.value === 'OSTCV-OT-DN-CUR-KVR-S0');
      if (isOttomanCoverModifierSelected) {
        inferredAddOnPrice = productDetails.inferredAddOn?.product?.price?.raw || 0;
      }
    }

    return modifierPriceAdjust + inferredAddOnPrice;
  }

  getPricing(option) {
    const {
      addOnBundleDiscount,
      priceAdjust,
      pricing,
      value,
    } = option;
    const totalPriceAdjust = pricing?.price || this.getTotalPriceAdjust(priceAdjust, value);
    const legacyOriginalPrice = (addOnBundleDiscount && totalPriceAdjust) || 0;
    const calculatedPrice = legacyOriginalPrice && totalPriceAdjust - addOnBundleDiscount;

    const originalPrice = pricing?.originalPrice || legacyOriginalPrice;
    const price = pricing?.price || calculatedPrice || totalPriceAdjust;

    return {
      price,
      originalPrice,
    };
  }

  renderCheckbox(option, onChange) {
    const {
      active,
      description,
      id,
      modals,
      selected,
      value,
      outOfStock,
    } = option;
    const { disabled, hrefLang, isProductAddonModifierOptionInventoryPending } = this.props;
    const currencyPrefix = getCurrencyPrefix({ hrefLang });
    const { price, originalPrice } = this.getPricing(option);

    const fetchedOutOfStock = !isProductAddonModifierOptionInventoryPending && outOfStock;

    // If the checkbox is selected and the product is out of stock,
    // trigger the onChange function to uncheck it
    if (selected && fetchedOutOfStock) {
      onChange();
    }

    return (
      <div
        className="pdp-options-checkbox-wrapper"
        key={id}
      >
        <div
          data-testid={description}
          className={classNames('pdp-options-checkbox', {
            active: active || selected,
            disabled: fetchedOutOfStock,
          })}
          onClick={() => !fetchedOutOfStock && onChange()}
          title={fetchedOutOfStock ? 'Out of stock' : undefined}
        >
          <input
            aria-label={description}
            data-cy={description}
            className={'pdp-options-checkbox-input'}
            defaultChecked={active}
            disabled={disabled}
            type="checkbox"
            name={value}
          />
          <span className="pdp-options-checkbox-label">{description}</span>&nbsp;
          {!!price && (
            <span data-testid="option-price" className="pdp-options-checkbox-price">+ {originalPrice > price
              ? <><s aria-hidden="true">{currencyPrefix}{originalPrice}</s> <span className="burgundy">{currencyPrefix}{price}</span></>
              : <>{currencyPrefix}{price}</>
            }
            </span>
          )}
        </div>
        {modals && this.renderModal(modals[0])}
      </div>
    );
  }

  render() {
    const {
      modifier,
      modifier: {
        slug,
        options,
      },
      toggleModifierOptionAction,
    } = this.props;

    return (
      <div className={classNames('pdp-options', slug)}>
        <div className="pdp-options-wrapper pdp-options-wrapper__column">
          {options.map((option) => (
            this.renderCheckbox(option, toggleModifierOptionAction.bind(this, { modifier, option }))
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  hrefLang: getHrefLang(state),
  isProductAddonModifierOptionInventoryPending: getIsProductAddonModifierOptionInventoryPending(state),
});

export default connect(mapStateToProps, null)(CheckboxModifiersComponent);
